import React, { Fragment } from 'react';
import GrowthAnalysisView from './GrowthAnalysisView';

// Thin route entry — the V3 shell lives inside the view.
const GrowthAnalysisReport = () => (
    <Fragment>
        <GrowthAnalysisView />
    </Fragment>
);

export default GrowthAnalysisReport;
